import {
  Avatar,
  Box,
  Button,
  Center,
  Checkbox,
  FileButton,
  Flex,
  Grid,
  Group,
  rgba,
  Select,
  Table,
  Tabs,
  Text,
  Textarea,
  TextInput,
  Title,
  Card,
  Stack,
  Divider,
  Paper,
  Badge,
} from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { proxyImage } from "../../_base/helper/ImageProxy";
import { SelectListItem } from "../../model/SelectListItem";
import { getUsersSelect } from "../../const/getSelectApi";
import { DateInput } from "@mantine/dates";
import {
  IconAddressBook,
  IconCalendar,
  IconCheck,
  IconEdit,
  IconFile,
  IconFlagUp,
  IconHomeLink,
  IconInfoTriangle,
  IconMailFilled,
  IconPhone,
  IconPhoto,
  IconPlus,
  IconRecordMail,
  IconRecycle,
  IconTrack,
  IconTrash,
  IconUpload,
  IconUser,
  IconUserCircle,
  IconZoomIn,
  IconLock,
} from "@tabler/icons-react";
import className from "./Profile.module.scss";
import { BoldControl } from "@mantine/tiptap";
import { modals } from "@mantine/modals";
import { ImageCore } from "../Flow-step/ImageCore";
import Signature, { SignatureRef, StrokeOptions } from "@uiw/react-signature";
import { uploadFile } from "../../_base/extension/Extension";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { randomId } from "@mantine/hooks";
import { UserProfileModel } from "../../model/UserProfileModel";
import { repositorySign } from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import { log } from "console";
import { useForm } from "@mantine/form";
import { rgb } from "pdf-lib";
import { UserModel } from "../../model/UserModel";
import { SystemConfigModel } from "../../model/SystemConfigModel";
import SignatureCanvas from "react-signature-canvas";
const ProFileView = () => {
  const [dataUser, setDataUser] = useState<SelectListItem[]>([]);
  const [fileSign, setFileSign] = useState<File | null>(null);
  const [fileBgSign, setFileBGSign] = useState<File | null>(null);
  const [fileAvatar, setFileAvatar] = useState<File | null>(null);

  const [imageUrl, setImageUrl] = useState<string>("");
  const [bgImageUrl, setBgImageUrl] = useState<string>("");
  const [avatarUrl, setAvatarUrl] = useState<string>("");

  const [notifications, setNotifications] = useState<SystemConfigModel[]>([]);
  const [cloudSign, setCloudSign] = useState<{
    user: string;
    pass: string;
    pin: string;
  }>({ user: "", pass: "", pin: "" });
  const _span = { base: 12, sm: 6, md: 4, lg: 4, xl: 4 };
  //  const $svg = useRef<SignatureRef>(null);
  // const $canvasbg = useRef<SignatureRef>(null);
  const [email_ignoerd, setEmailIgnored] = useState<string>("");
  let $canvas = useRef<SignatureCanvas>(null);
  let $canvasbg = useRef<SignatureCanvas>(null);
  let $canvasAvatart = useRef<SignatureCanvas>(null);

  const refSignDiv = useRef<HTMLDivElement>(null);
  const [options, setOptions] = useState<StrokeOptions>({
    size: 5,
    smoothing: 0.5,
    thinning: 0.5,
    streamline: 0.3,
  });

  const userProfile: UserModel = {
    id: 0,
    userName: "",
    passwordHash: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    avatar: "",
    forgotHash: "",
    imageSignatures: "",
    backgroundSignatures: "",
    digitalSignatures: "",
    defaultSignature: "",
    cloudSignatures: "",
    notSendMailTemplateKey: "",
    tsv: "",
    roleId: "",
    departmentId: "",
    code: "",
  };

  const form = useForm<UserModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...userProfile,
    },
    transformValues: (values) => ({
      ...values,
    }),
    validate: {
      email: (value) => {
        if (!value) {
          return "Vui lòng nhập email!";
        }
        return null;
      },
    },
  });

  const handleGetUserProfile = async () => {
    try {
      let url = `/api/v1/users/detail-username?userName=${localStorage.getItem(
        "userName"
      )}`;
      const response = await repositorySign.get<MessageResponse<UserModel>>(
        url
      );
      let data = response?.data;
      if (data) {
        form.initialize(data);
        // parse cloud signatures
        try {
          const parsed = JSON.parse(data.cloudSignatures ?? "[]");
          const first = Array.isArray(parsed) ? parsed.find((x) => x?.type === "intrustca") : null;
          if (first) {
            setCloudSign({
              user: first.user ?? "",
              pass: first.pass ?? "",
              pin: first.pin ?? "",
            });
          }
        } catch {
          setCloudSign({ user: "", pass: "", pin: "" });
        }
        if (data.assignFromDate)
          form.setFieldValue("assignFromDate", new Date(data.assignFromDate));
        if (data.assignToDate)
          form.setFieldValue("assignToDate", new Date(data.assignToDate));
        if (data.assignUserId)
          form.setFieldValue("assignUserId", data.assignUserId.toString());
        // if ($canvas && $canvas.current) {
        //   $canvas.current.fromDataURL(data.imageSignatures);
        // }

        // if ($canvasbg && $canvasbg.current) {
        //   $canvasbg.current.fromDataURL(data.backgroundSignatures);
        // }

        if (data.avatar) {
          // $canvasAvatart.current.fromDataURL(data.avatar);
          setAvatarUrl(data.avatar);
        }
        setImageUrl(data.imageSignatures);
        setBgImageUrl(data.backgroundSignatures);

        setEmailIgnored(data.notSendMailTemplateKey || "");

        let urlresponseConfig = `/api/v1/SystemStepup/template`;
        const responseConfig = await repositorySign.get<
          MessageResponse<SystemConfigModel[]>
        >(urlresponseConfig);
        if (responseConfig?.httpStatusCode === 200)
          if (responseConfig.data) setNotifications(responseConfig.data);
      }
    } catch (error) {
      console.error("Error getting user profile: ", error);
    }
  };

  const handleSaveOrUpdateUserProfile = async (payload: UserModel) => {
    try {
      if (payload.id === 0 || payload.id === null) {
        NotificationExtension.Fails("Bạn chưa có thông tin tài khoản !");
        return;
      }
      const response = await repositorySign.post<MessageResponse<boolean>>(
        "/api/v1/users/update-profile",
        payload
      );
      if (response?.httpStatusCode === 200)
        if (response?.success) {
          localStorage.setItem("userLogin", JSON.stringify(form.getValues()));
          NotificationExtension.Success("Cập nhật thông tin thành công");
        } else {
          NotificationExtension.Fails("Cập nhật thông tin thất bại");
        }
    } catch (error) {
      console.error("Error saving or updating user profile: ", error);
    }
  };

  const fetchDataUser = async () => {
    const dataApi = await getUsersSelect();
    if (dataApi && dataApi.length > 0) {
      const data = dataApi.filter((item: any) => item.text !== null);
      setDataUser(data);
    }
  };

  // xử lý ảnh uplooad
  useEffect(() => {
    if (fileSign) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const imageData = fileReader.result;
        const imageUrl = `${imageData}`;
        //  $canvas.current?.fromDataURL(imageUrl);
        setImageUrl(imageUrl);
      };
      fileReader.readAsDataURL(fileSign ?? new Blob());
    } else {
      $canvas.current?.clear();
      setImageUrl("");
    }
  }, [fileSign]);

  // xử lý ảnh uplooad
  useEffect(() => {
    if (fileBgSign) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const imageData = fileReader.result;
        const imageUrl = `${imageData}`;
        //  $canvasbg.current?.fromDataURL(imageUrl);
        setBgImageUrl(imageUrl);
      };
      fileReader.readAsDataURL(fileBgSign ?? new Blob());
    } else {
      $canvasbg.current?.clear();
      setBgImageUrl("");
    }
  }, [fileBgSign]);

  useEffect(() => {
    if (fileAvatar) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const imageData = fileReader.result;
        const imageUrl = `${imageData}`;
        //    $canvasAvatart.current?.fromDataURL(imageUrl);
        setAvatarUrl(imageUrl);
      };
      fileReader.readAsDataURL(fileAvatar ?? new Blob());
    } else {
      setAvatarUrl("");
    }
  }, [fileAvatar]);

  useEffect(() => {
    fetchDataUser();
    handleGetUserProfile();
  }, []);

  return (
    <Box p={{ base: "sm", md: "md" }}>
      {/* Header Section */}
      <Card shadow="sm" p="md" radius="md" withBorder mb="lg">
        <Group justify="space-between" align="center">
          <div>
            <Title order={2} c="blue.7" mb="xs" fw={600}>
              Thông tin cá nhân
            </Title>
            <Text size="sm" c="dimmed">
              Quản lý thông tin tài khoản và cài đặt chữ ký của bạn
            </Text>
          </div>
          <Button
            leftSection={<IconFile size={16} />}
            color="blue"
            variant="filled"
            type="submit"
            form="profile-form"
            size="sm"
          >
            Lưu thông tin
          </Button>
        </Group>
      </Card>

      <Box
        component="form"
        id="profile-form"
        onSubmit={form.onSubmit(async (e: UserModel) => {
          e.imageSignatures = $canvas.current?.toDataURL() ?? imageUrl;
          e.backgroundSignatures = $canvasbg.current?.toDataURL() ?? bgImageUrl;
          e.avatar = avatarUrl;
          e.notSendMailTemplateKey = email_ignoerd;
          // Lưu chữ ký cloud dưới dạng mảng (tạm thời 1 phần tử intrustca)
          e.cloudSignatures = JSON.stringify([
            {
              type: "intrustca",
              user: cloudSign.user,
              pass: cloudSign.pass,
              pin: cloudSign.pin,
            },
          ]);
          await handleSaveOrUpdateUserProfile(e);
        })}
      >
        <Grid gutter={{ base: "sm", md: "md" }}>
          {/* Account Information */}
          <Grid.Col span={{ base: 12, lg: 6 }}>
            <Card shadow="sm" p="md" radius="md" withBorder h="100%">
              <Group mb="sm">
                <IconInfoTriangle size={18} color="var(--mantine-color-blue-6)" />
                <Title order={5} fw={500}>Thông tin tài khoản</Title>
              </Group>
              
              <Stack gap="sm">
                <Grid>
                  <Grid.Col span={{ base: 12, sm: 6 }}>
                    <TextInput
                      label="Tài khoản"
                      placeholder="Nhập tên đăng nhập"
                      leftSection={<IconInfoTriangle size={14} />}
                      disabled
                      size="sm"
                      key={form.key("userName")}
                      {...form.getInputProps("userName")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, sm: 6 }}>
                    <TextInput
                      label="Họ và tên"
                      placeholder="Nhập họ và tên"
                      leftSection={<IconUser size={14} />}
                      size="sm"
                      key={form.key("name")}
                      {...form.getInputProps("name")}
                    />
                  </Grid.Col>
                </Grid>

                <Grid>
                  <Grid.Col span={{ base: 12, sm: 6 }}>
                    <TextInput
                      label="Email"
                      placeholder="Email"
                      leftSection={<IconMailFilled size={14} />}
                      size="sm"
                      key={form.key("email")}
                      {...form.getInputProps("email")}
                      required
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, sm: 6 }}>
                    <TextInput
                      label="Số điện thoại"
                      placeholder="Số điện thoại"
                      leftSection={<IconPhone size={14} />}
                      size="sm"
                      key={form.key("phone")}
                      {...form.getInputProps("phone")}
                    />
                  </Grid.Col>
                </Grid>

                <TextInput
                  label="Địa chỉ"
                  placeholder="Địa chỉ"
                  leftSection={<IconHomeLink size={14} />}
                  size="sm"
                  key={form.key("address")}
                  {...form.getInputProps("address")}
                />
              </Stack>
            </Card>
          </Grid.Col>

          {/* Authorization */}
          <Grid.Col span={{ base: 12, lg: 6 }}>
            <Card shadow="sm" p="md" radius="md" withBorder h="100%">
              <Group mb="sm">
                <IconUserCircle size={18} color="var(--mantine-color-green-6)" />
                <Title order={5} fw={500}>Ủy quyền phê duyệt</Title>
              </Group>

              <Stack gap="sm">
                <Select
                  label="Ủy quyền"
                  placeholder="Chọn người được ủy quyền..."
                  leftSection={<IconUserCircle size={14} />}
                  clearable
                  searchable
                  size="sm"
                  limit={30}
                  data={dataUser.map((item) => ({
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  }))}
                  key={form.key("assignUserId")}
                  {...form.getInputProps("assignUserId")}
                />

                <Grid>
                  <Grid.Col span={{ base: 12, sm: 6 }}>
                    <DateInput
                      label="Từ ngày"
                      leftSection={<IconCalendar size={14} />}
                      valueFormat="DD/MM/YYYY"
                      placeholder="Từ ngày..."
                      clearable
                      size="sm"
                      key={form.key("assignFromDate")}
                      {...form.getInputProps("assignFromDate")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, sm: 6 }}>
                    <DateInput
                      label="Đến ngày"
                      leftSection={<IconCalendar size={14} />}
                      valueFormat="DD/MM/YYYY"
                      placeholder="Đến ngày..."
                      clearable
                      size="sm"
                      key={form.key("assignToDate")}
                      {...form.getInputProps("assignToDate")}
                    />
                  </Grid.Col>
                </Grid>
              </Stack>
            </Card>
          </Grid.Col>

          {/* Avatar Section */}
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Card shadow="sm" p="md" radius="md" withBorder h="100%">
              <Group mb="sm">
                <IconUser size={18} color="var(--mantine-color-orange-6)" />
                <Title order={6} fw={500}>Ảnh đại diện</Title>
              </Group>

              <Stack align="center" gap="sm">
                <Box
                  style={{
                    border: !avatarUrl ? "2px dashed #e9ecef" : "none",
                    borderRadius: "8px",
                    padding: avatarUrl ? "0" : "15px",
                    minHeight: "100px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {avatarUrl ? (
                    <ImageCore src={proxyImage(avatarUrl, { width: 400 }) || avatarUrl} />
                  ) : (
                    <Text size="xs" c="dimmed" ta="center">
                      Chưa có ảnh đại diện
                    </Text>
                  )}
                </Box>

                <FileButton onChange={setFileAvatar} accept="image/png">
                  {(props) => (
                    <Button
                      size="xs"
                      variant="light"
                      leftSection={<IconUpload size={14} />}
                      {...props}
                      fullWidth
                    >
                      Chọn ảnh
                    </Button>
                  )}
                </FileButton>
              </Stack>
            </Card>
          </Grid.Col>

          {/* Signature Section */}
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Card shadow="sm" p="md" radius="md" withBorder h="100%">
              <Group mb="sm" justify="space-between">
                <Group>
                  <IconEdit size={18} color="var(--mantine-color-blue-6)" />
                  <Title order={6} fw={500}>Chữ ký ảnh</Title>
                </Group>
                
                <Group gap="xs">
                  {!imageUrl && (
                    <FileButton onChange={setFileSign} accept="image/png">
                      {(props) => (
                        <Button
                          size="xs"
                          variant="light"
                          leftSection={<IconUpload size={12} />}
                          {...props}
                        >
                          Chọn ảnh
                        </Button>
                      )}
                    </FileButton>
                  )}
                  <Button
                    size="xs"
                    variant="light"
                    color="red"
                    leftSection={<IconRecycle size={12} />}
                    onClick={() => {
                      $canvas.current?.clear();
                      setImageUrl("");
                      setFileSign(null);
                    }}
                  >
                    Xóa
                  </Button>
                </Group>
              </Group>

              <Box
                style={{
                  border: !imageUrl ? "2px dashed #e9ecef" : "1px solid #e9ecef",
                  borderRadius: "8px",
                  minHeight: "120px",
                  overflow: "hidden",
                }}
              >
                {!imageUrl && (
                  <SignatureCanvas
                    canvasProps={{
                      className: `${className.sigCanvas}`,
                      style: { width: "100%", height: "120px" },
                    }}
                    ref={$canvas}
                  />
                )}
                {imageUrl && <ImageCore src={imageUrl} />}
              </Box>
            </Card>
          </Grid.Col>

          {/* Background Signature Section */}
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Card shadow="sm" p="md" radius="md" withBorder h="100%">
              <Group mb="sm" justify="space-between">
                <Group>
                  <IconPhoto size={18} color="var(--mantine-color-green-6)" />
                  <Title order={6} fw={500}>Ảnh nền chữ ký</Title>
                </Group>
                
                <Group gap="xs">
                  {!bgImageUrl && (
                    <FileButton onChange={setFileBGSign} accept="image/png">
                      {(props) => (
                        <Button
                          size="xs"
                          variant="light"
                          leftSection={<IconUpload size={12} />}
                          {...props}
                        >
                          Chọn ảnh
                        </Button>
                      )}
                    </FileButton>
                  )}
                  <Button
                    size="xs"
                    variant="light"
                    color="red"
                    leftSection={<IconRecycle size={12} />}
                    onClick={() => {
                      setBgImageUrl("");
                      $canvasbg.current?.clear();
                      setFileBGSign(null);
                    }}
                  >
                    Xóa
                  </Button>
                </Group>
              </Group>

              <Box
                style={{
                  border: !bgImageUrl ? "2px dashed #e9ecef" : "1px solid #e9ecef",
                  borderRadius: "8px",
                  minHeight: "120px",
                  overflow: "hidden",
                }}
              >
                {!bgImageUrl && (
                  <SignatureCanvas
                    canvasProps={{
                      className: `${className.sigCanvas}`,
                      style: { width: "100%", height: "120px" },
                    }}
                    ref={$canvasbg}
                  />
                )}
                {bgImageUrl && <ImageCore src={bgImageUrl} />}
              </Box>
            </Card>
          </Grid.Col>

          {/* Cloud Signature Section */}
          <Grid.Col span={{ base: 12, lg: 6 }}>
            <Card shadow="sm" p="md" radius="md" withBorder>
              <Group justify="space-between" mb="sm">
                <Group>
                  <IconTrack size={18} color="var(--mantine-color-cyan-6)" />
                  <Title order={5} fw={500}>Chữ ký Cloud</Title>
                </Group>
              </Group>

              <Stack gap="sm">
                <Text size="sm" c="dimmed">
                  Lưu thông tin chữ ký cloud (tạm thời chỉ hỗ trợ IntrustCA)
                </Text>
                <Grid gutter="sm">
                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <TextInput
                      label="Tài khoản (user)"
                      placeholder="Nhập user IntrustCA"
                      size="sm"
                      value={cloudSign.user}
                      onChange={(e) =>
                        setCloudSign((prev) => ({ ...prev, user: e.currentTarget.value }))
                      }
                      leftSection={<IconUser size={14} />}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <TextInput
                      label="Mật khẩu"
                      placeholder="Nhập mật khẩu"
                      type="password"
                      size="sm"
                      value={cloudSign.pass}
                      onChange={(e) =>
                        setCloudSign((prev) => ({ ...prev, pass: e.currentTarget.value }))
                      }
                      leftSection={<IconLock size={14} />}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 4 }}>
                    <TextInput
                      label="PIN"
                      placeholder="Nhập PIN"
                      type="password"
                      size="sm"
                      value={cloudSign.pin}
                      onChange={(e) =>
                        setCloudSign((prev) => ({ ...prev, pin: e.currentTarget.value }))
                      }
                      leftSection={<IconLock size={14} />}
                    />
                  </Grid.Col>
                </Grid>
              </Stack>
            </Card>
          </Grid.Col>

          {/* Email Notifications */}
          <Grid.Col span={12}>
            <Card shadow="sm" p="md" radius="md" withBorder>
              <Group mb="sm">
                <IconRecordMail size={18} color="var(--mantine-color-violet-6)" />
                <Title order={5} fw={500}>Cài đặt email thông báo</Title>
              </Group>

              <Box style={{ overflowX: "auto" }}>
                <Table striped highlightOnHover withTableBorder>
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>Mã thông báo</Table.Th>
                      <Table.Th>Miêu tả thông báo</Table.Th>
                      <Table.Th ta="center">Nhận email</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {notifications
                      .filter(
                        (x) =>
                          x.keyGroup === "mail_template_group" &&
                          x.description &&
                          x.description.length > 0 &&
                          !x.key.includes("anonymous") &&
                          !x.key.includes("storage_limit_alert") &&
                          !x.key.includes("code_verify_template") &&
                          !x.key.includes("forgot_pasword_template") &&
                          !x.key.includes("organization_folder_limit_warning") &&
                          !x.key.includes("folder_reminder")
                      )
                      .map((notification) => (
                        <Table.Tr key={notification.id}>
                          <Table.Td>
                            <Badge variant="light" size="sm">
                              {notification.key}
                            </Badge>
                          </Table.Td>
                          <Table.Td>{notification.description}</Table.Td>
                          <Table.Td ta="center">
                            <Checkbox
                              onChange={(e) => {
                                const _check = e.target.checked;
                                if (!_check) {
                                  if (!(email_ignoerd || "").includes(notification.key)) {
                                    const _kkk = (email_ignoerd || "") + "," + notification.key;
                                    setEmailIgnored(_kkk);
                                  }
                                } else {
                                  if ((email_ignoerd || "").includes(notification.key)) {
                                    const _kkk = (email_ignoerd || "").replace(notification.key, "");
                                    setEmailIgnored(_kkk);
                                  }
                                }
                              }}
                              checked={!(email_ignoerd || "").includes(notification.key)}
                            />
                          </Table.Td>
                        </Table.Tr>
                      ))}
                  </Table.Tbody>
                </Table>
              </Box>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
    </Box>
  );
};

export default ProFileView;
